import React from "react";
import { AssetImageUrl } from "../../../../../assets/imgUrl";
import {
	AccountItem,
	AccountList,
	Cart,
	Favorites,
	IconArea,
	UserName,
	LoginButton,
	NotLoggedIn,
	NotLoggedInButtons,
	RegisterButton,
	Account,
	Icon,
	ActiveIcon,
	WelcomeTitle,
	CartCount,
	CartList,
	CartEmpty,
	CartMoreItems,
	CartProductList,
	CartProduct,
	CartProductImgArea,
	CartProductImgLink,
	CartProductImg,
	CartProductInfoArea,
	CartProductInfoTitle,
	CartProductInfoLink,
	CartProductInfoAttrPrice,
	CartProductInfoAttr,
	CartProductInfoPrice,
	CartProductTotal,
	CartProductPrice,
	CartProductBottom,
	MyCart,
	Checkout,
	CheckoutArrow,
	HeaderLogo,
	HeaderButtons,
	CartProductInfoColor,
	HeaderPageLet,
	HeaderRightArea,
} from "./styles";
import { Triangle, TriangleShadow } from "../../styles";
import { userLoginout } from "../../../../../headerServices/header/header";
import Constant, { delKeyFromCookie, WEB_HOST } from "../../../../../utils/constant";
import langGroup from "../../../../../assets/lang.json";
import getLangKeyValueFun from "../../../../../utils/lang";
import { MIDDLE_QUERY, SEARCH_RESULT } from "../../utils";
import { CartStore } from "../../index";

const getText = getLangKeyValueFun(langGroup);

interface WebHeaderPageLetProps {
	cart: CartStore;
	userName: string;
}

interface WebHeaderPageLetState {
	topKeyWords: any[];
}

class WebHeaderPageLet extends React.Component<WebHeaderPageLetProps, WebHeaderPageLetState> {
	constructor(props) {
		super(props);
		this.state = {
			topKeyWords: [],
		};
	}

	onLogOff = () => {
		userLoginout({
			sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined,
		})
			.then((res: any) => {
				if (res.info?.logoff_status) {
					/** del sessionKey */
					delKeyFromCookie("sessionKey");
					location.reload();
				}
			})
			.catch((err) => console.error(err));
	};

	onMainPage = (mainPage?: string) => {
		const { userName } = this.props;
		let query = "login";
		if (userName) {
			switch (mainPage) {
				case "Orders":
					query = "account";
					break;
				case "Favorites":
					query = "wish_list";
					break;
				case "Tickets":
					query = "ticket_center";
					break;
				case "Rewards":
					query = "store_credit";
					break;
				case "Coupons":
					query = "coupon_list";
					break;
				case "Cart":
				case "Checkout":
					query = "shopping_cart";
					break;
				default:
					query = "login";
			}
		}
		location.href = `${MIDDLE_QUERY()}${query}`;
	};

	onProductPage = (products_url: string, item_id: number) => {
		location.href = `${WEB_HOST[Constant.isUat ? "UAT" : "Online"].ghost}/${
			Constant.language
		}/p/${products_url}_p${item_id}.html`;
	};

	onSearchPage = (keyword: string) => {
		location.href = `${SEARCH_RESULT()}${keyword}`;
	};

	render() {
		const { cart, userName } = this.props;
		const currencySymbol = cart?.currencySymbol || `${cart?.items?.[0]?.currency || ""} `;
		return (
			<HeaderPageLet>
				{this.props.children}
				<HeaderLogo href="https://www.ador.com">
					<img src={AssetImageUrl["pc_logo"]} alt="ador" style={{ height: "44px" }} />
				</HeaderLogo>
				<HeaderRightArea>
					<HeaderButtons>
						<Account>
							<IconArea onClick={() => this.onMainPage()}>
								<Icon
									src={AssetImageUrl["pc_account"]}
									alt="Account"
									style={{ width: "25px", height: "25px" }}
								/>
								<ActiveIcon
									src={require("assets/images/mine_a.png")}
									alt="Account"
									style={{ width: "25px", height: "25px" }}
								/>
								{/* <IconName>{userName || getText("Sign In")}</IconName> */}
							</IconArea>
							<AccountList>
								<Triangle style={{ left: "50%" }} />
								<TriangleShadow style={{ left: "50%" }} />
								{!userName && (
									<NotLoggedIn>
										<WelcomeTitle>{getText("Welcome to Ador")}</WelcomeTitle>
										<NotLoggedInButtons>
											<RegisterButton onClick={() => this.onMainPage()}>
												{getText("Register")}
											</RegisterButton>
											<LoginButton onClick={() => this.onMainPage()}>
												{getText("Sign In")}
											</LoginButton>
										</NotLoggedInButtons>
									</NotLoggedIn>
								)}
								{userName && <UserName>{userName}</UserName>}
								<AccountItem onClick={() => this.onMainPage("Orders")}>
									{getText("My Orders")}
								</AccountItem>
								<AccountItem onClick={() => this.onMainPage("Favorites")}>
									{getText("My Favorites")}
								</AccountItem>
								<AccountItem onClick={() => this.onMainPage("Tickets")}>
									{getText("My Tickets")}
								</AccountItem>
								<AccountItem onClick={() => this.onMainPage("Rewards")}>
									{getText("My Rewards & Credit")}
								</AccountItem>
								<AccountItem onClick={() => this.onMainPage("Coupons")}>
									{getText("My Coupons")}
								</AccountItem>
								{userName && (
									<AccountItem onClick={this.onLogOff}>
										{getText("Sign Out")}
									</AccountItem>
								)}
							</AccountList>
						</Account>
						<Favorites>
							<IconArea onClick={() => this.onMainPage("Favorites")}>
								<Icon
									src={AssetImageUrl["pc_like"]}
									alt="Favorites"
									style={{ width: "25px", height: "25px" }}
								/>
								<ActiveIcon
									src={require("assets/images/collect_a.png")}
									alt="Favorites"
									style={{ width: "25px", height: "25px" }}
								/>
								{/* <IconName>{getText("Favorites")}</IconName> */}
							</IconArea>
						</Favorites>
						<Cart>
							<IconArea onClick={() => this.onMainPage("Cart")}>
								<CartCount>
									{cart.totalLen > 999 ? "999+" : cart.totalLen}
								</CartCount>
								<Icon
									src={AssetImageUrl["pc_cart"]}
									alt="Cart"
									style={{ width: "25px", height: "25px" }}
								/>
								<ActiveIcon
									src={require("assets/images/cart_a.png")}
									alt="Cart"
									style={{ width: "25px", height: "25px" }}
								/>
								{/* <IconName>{getText("Cart")}</IconName> */}
							</IconArea>
							<CartList className={!cart.totalLen && "isEmpty"}>
								<Triangle style={{ left: "91%" }} />
								<TriangleShadow style={{ left: "91%" }} />
								{!cart.totalLen && (
									<React.Fragment>
										<CartEmpty />
										{getText("Your shopping cart is empty")}.
									</React.Fragment>
								)}
								{!!cart.totalLen && (
									<React.Fragment>
										<CartMoreItems>
											{`${cart.totalLen} ${getText(
												"items in shopping cart",
											)}`}
										</CartMoreItems>
										<CartProductList>
											{(cart.items || []).map((item, index) => (
												<CartProduct
													key={index}
													className={index && "split"}
													onClick={() =>
														this.onProductPage(
															item?.products_url,
															item?.item_id,
														)
													}>
													<CartProductImgArea>
														<CartProductImgLink>
															<CartProductImg
																src={item?.thumbnail_img_url}
															/>
														</CartProductImgLink>
													</CartProductImgArea>
													<CartProductInfoArea>
														<CartProductInfoTitle>
															<CartProductInfoLink>
																{item?.item_name}
															</CartProductInfoLink>
														</CartProductInfoTitle>
														<CartProductInfoAttrPrice>
															<CartProductInfoAttr>
																{(item?.display_skus || []).map(
																	(i, idx) => (
																		<React.Fragment key={idx}>
																			<CartProductInfoColor
																				className={
																					idx && "split"
																				}>
																				{i
																					.split("-")[0]
																					.trim()}
																				:
																			</CartProductInfoColor>
																			{i.split("-")[1].trim()}
																		</React.Fragment>
																	),
																)}
															</CartProductInfoAttr>
															<CartProductInfoPrice>
																{currencySymbol}
																{item?.total_price}
															</CartProductInfoPrice>
														</CartProductInfoAttrPrice>
													</CartProductInfoArea>
												</CartProduct>
											))}
										</CartProductList>
										<CartProductTotal>
											{getText("Cart Total")}:&nbsp;
											<CartProductPrice>
												{currencySymbol}
												{cart.totalPrice}
											</CartProductPrice>
										</CartProductTotal>
										<CartProductBottom>
											<MyCart onClick={() => this.onMainPage("Cart")}>
												{getText("View My Cart")}
												<CheckoutArrow src={AssetImageUrl["pc_arrow"]} />
											</MyCart>

											<Checkout onClick={() => this.onMainPage("Checkout")}>
												{getText("Proceed to Checkout")}
											</Checkout>
										</CartProductBottom>
									</React.Fragment>
								)}
							</CartList>
						</Cart>
					</HeaderButtons>
				</HeaderRightArea>
			</HeaderPageLet>
		);
	}
}

export default WebHeaderPageLet;
